import {connect} from 'react-redux'
import {ActionsRow, DetailValue, Icon, Loader} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import ObjednavkaPotvrzeniRow from "../components/ObjednavkaPotvrzeniRow";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {withRouter} from "react-router";
import StavObjednavka from "../components/StavObjednavka";
import {formatDate, formatDateTime, formatTime} from "../utils/utils";
import Title from "../components/Title";
import './CenovaNabidkaPage.scss';
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka provádějící a zobrazující odmítnutí či přijetí cenové nabídky.
 * Pozor, na této stránce nemusí být (a většinou nebude) uživatel přihlášen, takže může volat pouze anonymně dostupné API!
 */
class CenovaNabidkaPage extends Component<WithTranslation> {

    constructor(props) {
        super(props);
        this.state = {
            potvrzeno: null,
            text: null,
            objednavka: null,
        };
    }

    componentDidMount() {
        const {guid, confirm} = this.props.match.params;
        const {t} = this.props;
        const potvrzeno = confirm === "true";
        ObjednavkaApi.objednavkaLink(guid, potvrzeno).then(() => {
            this.setState({
                potvrzeno,
                text: potvrzeno ? t('price_offer_accepted') : t('price_offer_declined'),
            });
            ObjednavkaApi.getObjednavkaByGuid(guid).then(objednavka => {
                this.setState({objednavka});
            });
        });
    }

    render() {
        const {potvrzeno, text} = this.state;
        const {t} = this.props;
        const objednavka = this.state.objednavka;
        let objednavkaContent = <Loader/>;
        if (objednavka) {
            const posledniZmena = objednavka.objednavkaZmenaList && objednavka.objednavkaZmenaList.length > 0 ? objednavka.objednavkaZmenaList.reduce((prev, curr) => prev.datumZmena > curr.datumZmena ? prev : curr) : null;
            const naPobocku = objednavka.datumVyzvednuti && objednavka.casVyzvednuti;
            const datumCas = naPobocku ? t('pickup_date_format',{pickupDate: formatDate(objednavka.datumVyzvednuti), pickupTime: formatTime(objednavka.casVyzvednuti)}) : t('pickup_date_format2', {pickupDate: formatDate(objednaka.datumDoruceni), pickupTimeFrom: formatTime(objednavka.terminDopravaCasDoruceniOd), pickupTimeTo: formatTime(objednavka.terminDopravaCasDoruceniDo)});
            let souboryContent = <i>{t('no_files')}</i>;
            if (objednavka.objednavkaSouborList && objednavka.objednavkaSouborList.length > 0) {
                souboryContent = objednavka.objednavkaSouborList.map(soubor =>
                    <CardBody key={soubor.id}><span><Icon icon="file" /> {soubor.nazevSoubor}</span></CardBody>
                );
            }
            objednavkaContent = <Row className="w-100 mt-3 mr-1">
                <Col xs={12} md={6}>
                    <Card>
                        <CardHeader>
                            <ActionsRow>
                                <h2>{t('basic_information')}</h2>
                            </ActionsRow>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col xs={4}>
                                    <DetailValue label={t('state')}><StavObjednavka stav={objednavka.stavObjednavka}/></DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('order.date_created')}>{formatDateTime(objednavka.datumZapis)}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('order.date_last_change')}>{posledniZmena ? formatDateTime(posledniZmena.datumZmena) : null}</DetailValue>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader>
                            <ActionsRow>
                                <h2>{t('order.parameters')}</h2>
                            </ActionsRow>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col xs={4}>
                                    <DetailValue label={t('order.number_of_copies')}>{objednavka.pocetVyhotoveni}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('order.stamping')}>{objednavka.razitkovat ? t('yes') : t('no')}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('order.number_series')}>{objednavka.razCiselnaRada}</DetailValue>
                                </Col>
                                {objednavka.objednavkaUkonList.map(ukon =>
                                    <Col xs={4} key={ukon.id}>
                                        <DetailValue label={ukon.nazevUkon}>{ukon.popisUkonPolozka}</DetailValue>
                                    </Col>
                                )}
                                <Col xs={12}>
                                    <DetailValue label={t('order.customer_note')}>{objednavka.poznamka}</DetailValue>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={12} md={6}>
                    <Card>
                        <CardHeader>
                            <ActionsRow>
                                <h2>Kontaktní informace</h2>
                            </ActionsRow>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col xs={4}>
                                    <DetailValue label={t('contact_information')}>{objednavka.uzivatelObjednalJmeno}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('email')}>{objednavka.email}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('phone')}>{objednavka.telefon}</DetailValue>
                                </Col>
                                <Col xs={4}/>
                                {/*<Col xs={4}>*/}
                                    {/*<DetailValue label="Notifikace e-mail">{objednavka.notifikaceEmail ? "Ano" : "Ne"}</DetailValue>*/}
                                {/*</Col>*/}
                                {/*<Col xs={4}>*/}
                                    {/*<DetailValue label="Notifikace SMS">{objednavka.notifikaceSms ? "Ano" : "Ne"}</DetailValue>*/}
                                {/*</Col>*/}
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader>
                            <ActionsRow>
                                <h2>{t('order.delivery_and_payment')}</h2>
                            </ActionsRow>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col xs={4}>
                                    <DetailValue label={t('order.delivery_method')}>{objednavka.zpusobDopravaNazev}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={`${naPobocku ? t('order.date_and_time_of_pickup') : t('order.date_and_time_of_delivery')}`}>{datumCas}</DetailValue>
                                </Col>
                                <Col xs={4}>
                                    <DetailValue label={t('order.payment_method')}>{objednavka.zpusobPlatbaNazev}</DetailValue>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader>
                            <ActionsRow>
                                <h2>{t('included_files', {count: (objednavka.objednavkaSouborList.length ? objednavka.objednavkaSouborList.length : 0)})}</h2>
                            </ActionsRow>
                        </CardHeader>
                        <CardBody>
                            {souboryContent}
                        </CardBody>
                    </Card>
                </Col>
                <Col className="d-flex justify-content-center mt-3 mb-3">
                    <Button color="primary" onClick={() => this.props.history.push('/')}>{t('go_to_app')}</Button>
                </Col>
            </Row>
        }
        return text ?
            <Title title={t('price_offer')}>
                <div className="cenova-nabidka-page">
                    <ObjednavkaPotvrzeniRow success={potvrzeno} text={text}/>
                    {objednavkaContent}
                </div>
            </Title> : <Loader/>;
    }
}

export default withRouter(connect()(withTranslation()(CenovaNabidkaPage)));

